import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-preview-document',
  templateUrl: './preview-document.component.html',
  styleUrls: ['./preview-document.component.scss'],
})
export class PreviewDocumentComponent implements OnInit, OnDestroy {
  public loading = true;
  public reference: string = '';
  public makePosFixed = false;

  private $sub = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService
  ) { }

  ngOnInit(): void {
    this.eventService.howItWorksHide();

    this.$sub = this.route.params.subscribe((params) => {
      if (params.reference) {
        this.reference = params.reference;
      }
    });
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e: any) {
    if (e.target['scrollingElement'].scrollTop >= 300) {
      setTimeout(() => this.makePosFixed = true);
    } else {
      setTimeout(() => this.makePosFixed = false);
    }
  }

  ngOnDestroy(): void {
    this.$sub.unsubscribe();
    this.eventService.howItWorksShow();
  }

}
